















import { defineComponent } from '@vue/composition-api';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default defineComponent({
	components: {
		FontAwesomeIcon,
	},
	setup() {
		return {};
	},
});
